import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useI18n } from '~Hooks';
import Icon from '~ComponentsImproved/Icon';
import warningIcon from '../../../../../Assets/icons/warning.svg';

/** One quiet line in the same voice as AllergenList: "18+" pill plus a short note about ID. */
const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  color: var(--eposText);
`;

const Tag = styled.span`
  padding: 4px 9px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  border: 1px solid var(--eposBorderColor);
`;

const Note = styled.span`
  font-size: 12px;
  font-weight: 600;
  opacity: 0.7;
`;

/** Shown on age-restricted items so the shopper knows ID may be asked for before they reach checkout. */
const AgeRestrictionNotice: FC = () => {
  const { i18n } = useI18n();

  return (
    <Row data-testid="epos-age-restriction">
      <Icon src={warningIcon} color="var(--eposText)" width="15px" height="15px" />
      <Tag>{i18n('Express.Item.AgeRestricted.Tag')}</Tag>
      <Note>{i18n('Express.Item.AgeRestricted.Note')}</Note>
    </Row>
  );
};

export default memo(AgeRestrictionNotice);
